import React from "react";
import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import formatZdate from "../../../utils/formatZdate";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterRoleEdit = ({ buttonConfig, selectedItemId, isButtonClicked }) => {
  const getOneHandler = buttonConfig.getOneHandler;
  const editHandler = buttonConfig.editHandler;
  const closeHandler = buttonConfig.closeEditModal;

  const schema = z.object({
    role_name: z.string().nonempty(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const form = useForm({
    defaultValues: async () => {
      const data = await getOneHandler(selectedItemId);
      console.log(data);

      return {
        id: data.id,
        role_name: data.role_name,
        status: data.status,
        eff_start_date: formatZdate(data.eff_start_date),
        eff_end_date: data.eff_end_date ? formatZdate(data.eff_end_date) : null,
      };
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const onSubmit = async (data) => {
    const statusValue =
      form.getValues("status") === "true" || form.getValues("status") === true;
    const updatedData = { ...data, status: statusValue };
    const res = await editHandler(selectedItemId, updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  console.log(form.getValues("status"));

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[700px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[30%] max-sm:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Edit Role`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          {/* row 1 */}
          <div className="gap-2 sm:flex">
            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Role name *</label>
              <input
                placeholder=""
                {...form.register("role_name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.role_name && "border-[1px] border-red-300",
                )}
              />
            </div>

            <div className="flex h-full w-full flex-col gap-2 max-sm:mt-4">
              <label className="text-[#636363]">Status</label>
              <div
                className={cn(
                  " h-full rounded bg-neutral-100 px-2 py-[9px]",
                  errors.status && "border-[1px] border-red-300",
                )}
              >
                <select
                  {...form.register("status")}
                  className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                  defaultValue={form.getValues("status")}
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </select>
              </div>
            </div>
          </div>

          {/* row 2 */}
          <div className="items-end gap-2 sm:flex ">
            <div className="flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4 sm:mt-8">
              <div className="flex w-full  flex-col gap-2 ">
                <label>Start date *</label>
                <div className="relative flex w-full">
                  <CustomDateInput
                    max={form.getValues("eff_end_date")}
                    form1={form.register("eff_start_date")}
                    initialValue={form.getValues("eff_start_date")}
                    className={"w-full py-[0.7rem]"}
                  />
                </div>
              </div>
            </div>

            <div className="flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4 sm:mt-8">
              <div className="flex w-full  flex-col gap-2 ">
                <label>End date</label>
                <div className="relative flex w-full">
                  <CustomDateInput
                    form1={form.register("eff_end_date")}
                    min={form.getValues("eff_start_date")}
                    initialValue={form.getValues("eff_end_date")}
                    className={"w-full py-[0.7rem]"}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-between gap-2 sm:[&>button]:w-1/2">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-2 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "SAVE CHANGES"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop
      //  closeHandler={closeHandler}
      />
    </>
  );
};

export default MasterRoleEdit;
